var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSol = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 66,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#sol_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#460077",
  d: "M33.294 60.159c14.978 0 27.12-12.142 27.12-27.12 0-14.977-12.142-27.119-27.12-27.119-14.977 0-27.12 12.142-27.12 27.12 0 14.977 12.143 27.119 27.12 27.119"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8500D3",
  d: "M58.27 14.48H45.8v9.458h12.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8500D3",
  fillRule: "evenodd",
  d: "M8.32 23.938h20.245v34.448h9.458V23.938h.015V14.48H8.32z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8500D3",
  d: "M33.294 7.863c13.885 0 25.18 11.295 25.18 25.179S47.178 58.22 33.293 58.22 8.115 46.926 8.115 33.04c0-13.883 11.295-25.178 25.18-25.178m0-7.784C15.092.08.334 14.837.334 33.04S15.092 66 33.294 66s32.96-14.758 32.96-32.96S51.498.08 33.295.08"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.161 40.454c.218-.218.515-.344.832-.344h28.683c.524 0 .786.634.416 1.004l-5.667 5.667a1.17 1.17 0 0 1-.832.343H15.912a.588.588 0 0 1-.416-1.003l5.667-5.667zm-5.665-15.488a.588.588 0 0 0 .416 1.003h28.684c.316 0 .613-.128.831-.343l5.667-5.668a.588.588 0 0 0-.415-1.003H21.993c-.308 0-.605.128-.832.343l-5.667 5.668zm29.931 4.842a1.17 1.17 0 0 0-.831-.343H15.912a.588.588 0 0 0-.416 1.003l5.667 5.667c.218.218.515.343.832.343h28.684a.588.588 0 0 0 .415-1.003z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "sol_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.334 0h66v66h-66z"
})))));
export default SvgSol;